import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Person} from "../shared/types/types";
import {documentToHtmlString} from "@contentful/rich-text-html-renderer";
import {BLOCKS} from "@contentful/rich-text-types";

@Injectable({
  providedIn: 'root'
})
export class AboutUsService {

  constructor(private httpClient: HttpClient) {
  }

  async getAboutUsFromContentful(): Promise<Person[]> {
    const personList = await this.httpClient.get(
      'https://cdn.contentful.com/spaces/0yl50763pf02/environments/master/entries?access_token=q1y1kgfFDay3TtOOGa0_1AH4LzOld_soRc9yW41-LGs&content_type=content&fields.menu=Munkatársaink&include=3').toPromise();

    const entries = (personList as any).includes.Entry;
    return (personList as any).items.map((person: any) => {
      return person.fields.content.map((content: { sys: { id: string; }; }) => {
        const foundedPerson = entries.find((item: {
          sys: { id: string; };
        }) => item.sys.id === content.sys.id)

        const imageId = foundedPerson.fields.picture.sys.id;
        const image = (personList as any).includes.Asset.find((asset: any) => asset.fields.file.url.includes(imageId));

        console.log(person.fields.intro)


        const intro = documentToHtmlString(foundedPerson.fields.intro, {
          renderNode: {
            // [BLOCKS.PARAGRAPH]: (node, next) => `<p>${next(node.content).replace(/\n/g, '<br/>')}</p>`,
            [BLOCKS.HEADING_2]: (node, next) => `<br /><br /><h2>${next(node.content)}</h2>`
          }
        });

        return new Person(foundedPerson.fields.name, image.fields.file.url, foundedPerson.fields.job, foundedPerson.fields.mobile, intro);
      });
      }
    )[0];
  }
}
